<template>
  <div class="placeholders">
    <ContentPlaceholders
      title="AUTO-FILL TAGS"
      :placeholders="default_variables"
    />

    <ContentPlaceholders :placeholders="templateVariables" />

    <div v-if="emailComponents.length > 0">
      <div class="title">
        TEMPLATE COMPONENT
      </div>
      <div class="tags_wrapper xs-mb-20">
        <div
          v-for="(variable, index) in emailComponents"
          :id="`component-${index}`"
          :key="index"
          :class="{'component_active disabled': variable.active}"
          class="tag_item label label-info xs-mr-10"
          @click="copyVariableToClipboard(variable.variable_name, `component-${index}`)"
        >
          {{ variable.variable_name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentPlaceholders from "../../../../js/components/global/assets/ContentPlaceholders.vue";

export default {
  components: {ContentPlaceholders},
  props: {
    templateVariables: {
      type: Array,
      default: null,
    },
    emailComponents: {
      type: Object,
      default: null,
    }
  },

  data() {
    return {
      default_variables: {
        USER_NAME: "User Name",
        USER_EMAIL: "User Email",
        AGENCY_NAME: "Agency Name",
        AGENCY_EMAIL: "Agency Email",
        AGENCY_DOMAIN: "Agency Domain",
        DATE: "Date"
      },
    }
  },

  methods: {
    /** ***************************************************************//**
     * Copy Variable to Clipboard
     *
     * Copies the passed variable to the users clipboard so it can be be
     * pasted into the textarea form.
     *
     * @param {String} variable
     */
    copyVariableToClipboard(variable, id) {
      // Add double square brackets to variable before copying to clipboard
      navigator.clipboard.writeText(`[[${variable}]]`);
      // this.$notify(`Copied ${variable} to your clipboard!`);

      const element = document.getElementById(id);

      element.innerHTML = 'Copied to your clipboard!';
      setTimeout(() => {
        element.innerHTML = variable;
      }, 700);
    }
  }
}
</script>

<style scoped>
.tag_item:not(:last-of-type) {
  margin-bottom: 0.5rem;
}

.tag_item {
  border-radius: .75rem;
  background-color: #E8E5E2;
  padding: 10px;
  font-size: .8rem;
  line-height: 1;
  transition: .3s;
  user-select: none;
  cursor: pointer;
}

.tag_item:hover {
  color: #fff;
  background-color: #37B2A8;
}

.heading_h4 {
  line-height: 1.42;
  letter-spacing: -0.042em;
  color: #040707;
  font-size: 1.5rem;
  font-weight: 700;
}

.tags_wrapper {
  display: flex;
  flex-direction: column;
  color: #040707;
}

.title {
  text-align: center;
  font-size: .75rem;
  line-height: 1.25;
  letter-spacing: 3px;
  text-transform: uppercase;
  margin-bottom: 1.5em;
}

.placeholders > .title {
  text-align: center;
  font-size: .75rem;
  line-height: 1.25;
  letter-spacing: 3px;
  text-transform: uppercase;
  margin-bottom: 1.5em;
  color: #040707;
}

.component_active {
  opacity: 50%;
}
</style>
